module.exports = __webpack_public_path__ + "static/media/getFeedback.1833b5db.svg";